import { Injectable } from '@angular/core';
import { Timezone, TimezoneName } from './timzones.constants';

@Injectable({
  providedIn: 'root',
})
export class DateTimeService {
  private _zones = new Map<TimezoneName, Timezone>([
    ['Pacific Time (US & Canada)', 'America/Los_Angeles'],
    ['Mountain Time (US & Canada)', 'America/Denver'],
    ['Central Time (US & Canada)', 'America/Chicago'],
    ['Eastern Time (US & Canada)', 'America/New_York'],
  ]);

  toUTCDate(date: string): string {
    // Expects: 'MM-DD-YYYY HH:mm'
    return new Date(date + ' UTC').toISOString()
  }

  /**
   * 
   * @param date should be utc or iso date
   * @param zoneName for which zone you want to convert the date
   * @returns formatted date string.
   */
  toZoneDate(date: Date | string, zoneName: TimezoneName): string {
    const timeZone = this._zones.get(zoneName);
    if (!timeZone) throw new Error('Invalid timezone name');

    const dateObject = date instanceof Date ? date : new Date(date);

    const result = new Intl.DateTimeFormat('en-US', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).format(dateObject);

    return this.acvDateFormat(result);
  }

  get zones(): Map<TimezoneName, Timezone> {
    return this._zones;
  }

  getZone(zoneName: TimezoneName): Timezone | undefined {
    return this._zones.get(zoneName);
  }

  acvDateFormat(dateStr: string): string {
    if (!dateStr) {
      return '-';
    }
    return new Date(dateStr).toLocaleString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).replace(',', '').replaceAll('/', '-');
  }
}
